var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright_wrap"},[_vm._v("2016-2017 加优科技有限公司 版权所有 保留一切权利 备案号 1234567u8i")])}
var staticRenderFns = []

export { render, staticRenderFns }